import {Component, OnInit} from '@angular/core';
import {Observable} from 'rxjs';
import * as activePublication from '@app/components/publications/create-publication/_store/active-publication.reducers';
import {select, Store} from '@ngrx/store';
import {AppState, selectActivePublicationState} from '@store/app.states';
import {distinctUntilChanged} from 'rxjs/operators';
import {OnDestroyMixin, untilComponentDestroyed} from '@w11k/ngx-componentdestroyed';
import {AbstractControl, UntypedFormControl, UntypedFormGroup, ValidatorFn, Validators} from '@angular/forms';
import {RedirectInfosUpdate, SavePublication} from '@app/components/publications/create-publication/_store/active-publication.actions';
import {RedirectInfos} from '@models/active-publication.model';

@Component({
    selector: 'app-redirect-links',
    templateUrl: './redirect-links.component.html',
    styleUrls: ['./redirect-links.component.scss'],
    standalone: false
})
export class RedirectLinksComponent extends OnDestroyMixin implements OnInit {

  public getActivePublication$: Observable<activePublication.State> = this.store
    .pipe(
      select(selectActivePublicationState),
      distinctUntilChanged(),
      untilComponentDestroyed(this),
    );

  rawValues: RedirectInfos;
  params: string[];

  fLinks: UntypedFormGroup = new UntypedFormGroup({
    hasRedirectionLinks: new UntypedFormControl(false),
    complete: new UntypedFormControl(null, [this.urlValidator()]),
    screenout: new UntypedFormControl(null, [this.urlValidator()]),
  });

  publicationDatas = null;

  constructor(
    private store: Store<AppState>,
  ) {
    super();
  }

  ngOnInit(): void {

    this.getActivePublication$.pipe(untilComponentDestroyed(this)).subscribe((publication) => {

      if (publication.datas) {
        this.publicationDatas = publication.datas;
        // this.fLinks.patchValue(publication.datas.li)
        this.fLinks.patchValue(publication.datas.redirectInfos, {emitEvent: false});

        this.rawValues = this.fLinks.getRawValue();
        this.params = [...new Set([...this.extractMustacheTags(this.rawValues?.complete), ...this.extractMustacheTags(this.rawValues?.screenout)])];
      }

    });

    this.fLinks.valueChanges.subscribe(() => {
      if (this.fLinks.dirty) {

        this.rawValues = this.fLinks.getRawValue();
        this.store.dispatch(new RedirectInfosUpdate({redirectInfos: this.rawValues}));

        // const paramsComplete = this.rawValues?.complete?.match(/{{\s*[\w\.]+\s*}}/g)?.map(x => x.match(/[\w\.]+/)[0]) || [];
        // const paramsScreenout = this.rawValues?.screenout?.match(/{{\s*[\w\.]+\s*}}/g)?.map(x => x.match(/[\w\.]+/)[0]) || [];
        // const paramsComplete = this.extractMustacheTags(this.rawValues?.complete);
        // const paramsScreenout = this.extractMustacheTags(this.rawValues?.screenout);
        this.params = [...new Set([...this.extractMustacheTags(this.rawValues?.complete), ...this.extractMustacheTags(this.rawValues?.screenout)])];

      }
    });

  }

  extractMustacheTags(str): string[] {
    return str?.match(/{{\s*[\w\.]+\s*}}/g)?.map(x => x.match(/[\w\.]+/)[0]) || [];
  }

  urlValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (control.value) {

        const nControl: HTMLInputElement = document.createElement('input');
        nControl.type = 'url';
        nControl.value = control.value;
        // const isValid: boolean = nControl.checkValidity();
        const forbidden = !nControl.checkValidity();

        return forbidden ? {notValidUrl: {value: control.value}} : null;

      }
      return null;
    };
  }


  save(): void {
    this.store.dispatch(new SavePublication({publication: this.publicationDatas}));
  }


}
